import { render } from "./ActionList.vue?vue&type=template&id=0b04f0de"
import script from "./ActionList.vue?vue&type=script&lang=js"
export * from "./ActionList.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodeapps/vitamins/projectivegroup/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__